// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UsersGroup_wrapper","line":"UsersGroup_line","users":"UsersGroup_users","user":"UsersGroup_user","grayScale":"UsersGroup_grayScale","avatar":"UsersGroup_avatar"};